import React from 'react'
import { Link } from 'react-router-dom'
import Icon from '../misc/Icons'

class SearchResultsRepoCard extends React.Component{

	render(){	

		const {repo} = this.props
		const linkPath=`/packs/${repo.id}`

		return(
			<Link to={linkPath}>
				<div className='searchResultsCard searchResultsCard--repo'>									
					<div className='searchResultsCard-title'>
						{repo.name}
									
						{repo.shared && 
							<Icon name='shared' />
						}
					</div>
					<div className='searchResultsCard-rightArrow'>
						<Icon name='chevron-right' />
					</div>
				</div>
			</Link>
		)
	}
}




export default SearchResultsRepoCard



// WEBPACK FOOTER //
// ./src/components/search/SearchResultsRepoCard.js